
// You would replace this with your actual CSS or a styling library
const modalStyles = {
    overlay: {
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, 
        backgroundColor: 'rgba(0, 0, 0, 0.7)', display: 'flex', 
        justifyContent: 'center', alignItems: 'center', zIndex: 1002 
    },
    content: {
        backgroundColor: 'white', padding: '30px', borderRadius: '8px', 
        width: '60%', maxWidth: '90%', height: '70%'
    }
};


function UpdateEventModal({ data, isOpen, onClose, onUpdateSubmit, updateData}) {
    const handleChange = (e) => {
        const { name, value } = e.target;
        updateData(prevData => ({
            ...prevData,
            [name]: value,
        }));
    };

    // 2. Handle Submission Logic
    const handleSubmit = (e) => {
        e.preventDefault();
        
        // Pass the form data up to the parent component for API submission
        onUpdateSubmit(data);
        
        // Close the modal
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div style={modalStyles.overlay}>
            <div style={modalStyles.content}>
                <h2>Update</h2>
                <form onSubmit={handleSubmit}>
                    <div className="row g-0 d-flex flex-column">
                    <h6>Title</h6>
                    <input 
                        type="text" 
                        name="title" 
                        placeholder="Title" 
                        value={data.title} 
                        onChange={handleChange} 
                        required 
                    />
                    <h6>Content</h6>
                    <textarea 
                        name="content" 
                        placeholder="Content" 
                        value={data.content} 
                        onChange={handleChange} 
                        required
                    />
                    
                    <h6>Hover Text</h6>
                    <textarea 
                        name="hovertext" 
                        placeholder="Hover Text" 
                        value={data.hovertext} 
                        onChange={handleChange} 
                        required
                    />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '15px' }}>
                        <button type="button" className="btn btn-outline-secondary" onClick={onClose} style={{ marginRight: '10px' }}>Cancel</button>
                        <button type="submit" className="btn btn-primary">Update</button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default UpdateEventModal;